import { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useClientEvaluationDialog } from '../../../hooks/useDialog'
import Dialog from '../../atoms/feedback/Dialog'
import { FlexColumn, FlexRow } from '../../atoms/layout/Flex'
import Rating from '../../atoms/inputs/Rating'
import Table from '../../atoms/display/Table'
import TableRow from '../../atoms/display/TableRow'
import TableCell from '../../atoms/display/TableCell'
import Label from '../../atoms/display/Label'
import TextField from '../../atoms/inputs/TextField'
import FormItem from '../../molecules/inputs/FormItem'
import Button from '../../atoms/inputs/Button'
import { CompanyActions } from '../../../store/company'
import { CompanySelectors } from '../../../store/company/selectors'

export default function ClientEvaluationDialog() {
  const { state, close } = useClientEvaluationDialog()
  const [communicationSpeedPoint, setCommunicationSpeedPoint] = useState<number | null>(null)
  const [irregularitiesResponsePoint, setIrregularitiesResponsePoint] = useState<number | null>(null)
  const [budgetPoint, setBudgetPoint] = useState<number | null>(null)
  const [constructionSchedulePoint, setConstructionSchedulePoint] = useState<number | null>(null)
  const [technologyPoint, setTechnologyPoint] = useState<number | null>(null)
  const [comment, setComment] = useState<string | null | undefined>(null)
  const clientDetails = useSelector(CompanySelectors.clientDetails)
  const dispatch = useDispatch()
  const enableSave =
    communicationSpeedPoint &&
    irregularitiesResponsePoint &&
    budgetPoint &&
    constructionSchedulePoint &&
    technologyPoint
  const clientDetail = clientDetails?.find((detail) => detail.id === state?.companyId)

  useEffect(() => {
    dispatch(CompanyActions.fetchClientDetails())
  }, [dispatch])

  useEffect(() => {
    if (clientDetail?.evaluation) {
      setCommunicationSpeedPoint(clientDetail.evaluation.communicationSpeedPoint)
      setIrregularitiesResponsePoint(clientDetail.evaluation.irregularitiesResponsePoint)
      setBudgetPoint(clientDetail.evaluation.budgetPoint)
      setConstructionSchedulePoint(clientDetail.evaluation.constructionSchedulePoint)
      setTechnologyPoint(clientDetail.evaluation.technologyPoint)
    }
  }, [clientDetail?.evaluation])

  const handleSave = () => {
    if (
      state?.companyId &&
      communicationSpeedPoint &&
      irregularitiesResponsePoint &&
      budgetPoint &&
      constructionSchedulePoint &&
      technologyPoint
    ) {
      dispatch(
        CompanyActions.saveClientEvaluation({
          clientCompanyId: state?.companyId,
          communicationSpeedPoint,
          irregularitiesResponsePoint,
          budgetPoint,
          constructionSchedulePoint,
          technologyPoint,
          comment: comment ?? null,
        })
      )
    }
  }

  return (
    <Dialog
      open={state !== undefined}
      onClose={close}
      title="取引先の評価"
      actions={
        <FlexRow>
          <Button variant="text" onClick={close}>
            キャンセル
          </Button>
          <Button disabled={!enableSave} onClick={handleSave}>
            保存
          </Button>
        </FlexRow>
      }
    >
      <FlexColumn>
        <Table>
          <TableRow>
            <TableCell size="sm3">
              <Label text="連絡の速さ・まめさ" />
            </TableCell>
            <TableCell size="sm3">
              <Rating
                max={3}
                precision={1}
                value={communicationSpeedPoint ?? undefined}
                onChange={setCommunicationSpeedPoint}
              />
            </TableCell>
          </TableRow>
          <TableRow>
            <TableCell size="sm3">
              <Label text="イレギュラー対応" />
            </TableCell>
            <TableCell size="sm3">
              <Rating
                max={3}
                precision={1}
                value={irregularitiesResponsePoint ?? undefined}
                onChange={setIrregularitiesResponsePoint}
              />
            </TableCell>
          </TableRow>
          <TableRow>
            <TableCell size="sm3">
              <Label text="予算" />
            </TableCell>
            <TableCell size="sm3">
              <Rating max={3} precision={1} value={budgetPoint ?? undefined} onChange={setBudgetPoint} />
            </TableCell>
          </TableRow>
          <TableRow>
            <TableCell size="sm3">
              <Label text="工期を守っているか" />
            </TableCell>
            <TableCell size="sm3">
              <Rating
                max={3}
                precision={1}
                value={constructionSchedulePoint ?? undefined}
                onChange={setConstructionSchedulePoint}
              />
            </TableCell>
          </TableRow>
          <TableRow>
            <TableCell size="sm3">
              <Label text="技術" />
            </TableCell>
            <TableCell size="sm3">
              <Rating max={3} precision={1} value={technologyPoint ?? undefined} onChange={setTechnologyPoint} />
            </TableCell>
          </TableRow>
        </Table>
        <FormItem label="コメント">
          <TextField multiline rows={5} onChange={setComment} />
        </FormItem>
      </FlexColumn>
    </Dialog>
  )
}
